import React from 'react';
import { useNavigate } from 'react-router-dom'; // For navigation
import Navbar from '../components/Navbar';
import "../styles/CAD.css";

const BlockchainDevelopmentServices = () => {
  const navigate = useNavigate();

  // For demonstration, the "Learn More" buttons redirect to the contact page.
  // Adjust the navigation logic or target paths as needed.
  const handleNavigation = () => {
    window.location.href = "/contact";
  };

  return (
    <>
      <Navbar />
      <div className="custom-app-development">
        <div className="content-box">
          <header className="header">
            <h1>Blockchain Development Services</h1>
            <p className="tagline">
              Leverage the power of decentralized technology to drive innovation and trust.
            </p>
          </header>

          <section className="introduction">
            <p>
              In today’s rapidly evolving digital landscape, blockchain technology is transforming industries by ensuring security, transparency, and efficiency. Our Blockchain Development Services empower your organization to implement robust decentralized solutions that enhance business processes and build trust.
            </p>
          </section>

          <section className="why-choose-us">
            <h2>Why Choose Our Blockchain Services?</h2>
            <p>
              Our team of blockchain experts brings deep technical know‑how and industry insight. We specialize in platform consultation, smart contract development, NFT marketplace creation, dApp development, and secure wallet integration to deliver scalable and transparent solutions.
            </p>
          </section>

          <section className="tech-stack">
            <h2>Our Approach & Methodology</h2>
            <p>
              We follow a comprehensive, end‑to‑end process to implement blockchain solutions tailored to your business:
            </p>
            <ul>
              <li>
                <strong>Technology & Platform Consultation:</strong> With expertise in blockchain platform selection and integration, we guide you on the best technologies—like Ethereum, Polkadot, and more—to ensure successful implementation.
              </li>
              <li>
                <strong>NFT Marketplace & Token Deployment:</strong> Our specialists handle token creation, deployment, and custom NFT marketplace development for secure, efficient digital asset management.
              </li>
              <li>
                <strong>DApp Development:</strong> We build decentralized applications (dApps) featuring intuitive user interfaces paired with secure backend systems for seamless operations.
              </li>
              <li>
                <strong>Web3 Wallet Development:</strong> We develop secure crypto wallet applications with multi‑currency support, ensuring safe storage and smooth transactions.
              </li>
            </ul>
          </section>

          <section className="secure-practices">
            <h2>Secure & Transparent Solutions</h2>
            <p>
              Our blockchain solutions are engineered with the highest security standards and built to provide full transparency in transactions. We ensure that every implementation is compliant, resilient, and future‑proof.
            </p>
          </section>

          <section className="services">
            <h2>Our Blockchain Services</h2>
            <div className="service-container">
              <div className="service-box">
                <h3>Technology & Platform Consultation</h3>
                <p>
                  Get expert guidance on selecting and integrating the right blockchain technology for your business.
                </p>
                <button className="learn-more" onClick={handleNavigation}>
                  Learn More
                </button>
              </div>
              <div className="service-box">
                <h3>NFT Marketplace & Token Deployment</h3>
                <p>
                  From token creation to building custom NFT marketplaces, we ensure a secure, seamless ecosystem for digital asset transactions.
                </p>
                <button className="learn-more" onClick={handleNavigation}>
                  Learn More
                </button>
              </div>
              <div className="service-box">
                <h3>DApp Development</h3>
                <p>
                  We develop decentralized applications (dApps) that combine user-friendly interfaces with robust, secure backend infrastructure.
                </p>
                <button className="learn-more" onClick={handleNavigation}>
                  Learn More
                </button>
              </div>
              <div className="service-box">
                <h3>Web3 Wallet Development</h3>
                <p>
                  Our secure wallet development services include multi‑currency support and seamless integration to safeguard your digital assets.
                </p>
                <button className="learn-more" onClick={handleNavigation}>
                  Learn More
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default BlockchainDevelopmentServices;
